const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

const isMobile = () => window.innerWidth <= 768;

function updateHeader() {
  const headerFloatingMegaMenu = document.querySelector('.header-floating-mega-menu');
  const headerWrapper = document.querySelector('.header-wrapper');
  const isHomePage = window.location.pathname === '/';
  const scrollTop = window.scrollY;
  const mobile = isMobile();
  const isMenuOpen = headerFloatingMegaMenu && headerFloatingMegaMenu.classList.contains('active');
  const isTopHome = isHomePage && scrollTop === 0;
  const isTransparentTop = isTopHome && !(isMenuOpen && mobile);

  if (headerWrapper) {
    headerWrapper.classList.toggle('header-wrapper--transparent-top', isTransparentTop);

    if (isTransparentTop) {
      headerWrapper.style.backgroundColor = 'transparent';
    } else {
      headerWrapper.style.backgroundColor = 'white';
    }
  }
}

window.addEventListener('scroll', updateHeader);
updateHeader();

document.addEventListener('DOMContentLoaded', function () {
  const toggleHeaderMenu = document.querySelector('.toggle-header-menu');
  const headerFloatingMegaMenu = document.querySelector('.header-floating-mega-menu');
  const body = document.querySelector('body.gradient');
  const headerDesktopBackdrop = document.querySelector('.header-desktop-backdrop');
  
  function toggleHeader() {
    const headerMenuOpen = document.querySelector('.header-menu-open');
    const headerMenuClose = document.querySelector('.header-menu-close');

    if (headerFloatingMegaMenu.classList.contains('active')) {
      headerMenuOpen.style.display = 'flex';
      headerMenuClose.style.display = 'none';
      body.classList.remove('menu-open');
    } else {
      headerMenuOpen.style.display = 'none';
      headerMenuClose.style.display = 'block';
      body.classList.add('menu-open');
    }

    headerFloatingMegaMenu.classList.toggle('active');
    headerDesktopBackdrop.classList.toggle('active');

    updateHeader();
  }

  toggleHeaderMenu.addEventListener('click', (event) => {
    event.stopPropagation();
    toggleHeader();
  });

  document.addEventListener('click', (event) => {
    if (
      headerFloatingMegaMenu.classList.contains('active') &&
      !headerFloatingMegaMenu.contains(event.target) &&
      !toggleHeaderMenu.contains(event.target)
    ) {
      toggleHeader();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && headerFloatingMegaMenu.classList.contains('active')) {
      toggleHeader();
    }
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const dropdownHeaders = document.querySelectorAll(".link-dropdown-header");
//   const girlsDropdownHeaders = document.querySelectorAll(
//     '.link-dropdown-item[data-parent="GIRLS"]'
//   );
//   girlsDropdownHeaders.forEach((header) => {
//     const linkDropdownHeader = header.querySelector(".link-dropdown-header");
//     const dropdownContent = linkDropdownHeader.nextElementSibling;
//     const dropdownItems = dropdownContent.querySelectorAll('span').length;
//     const dropdownHeight = dropdownContent.querySelector('span').scrollHeight * dropdownItems + 30;

//     dropdownContent.style.height = `${dropdownHeight}px`;
//     linkDropdownHeader.querySelector("svg").style.transform = "rotate(180deg)";
//   });

//   dropdownHeaders.forEach((header) => {
//     header.addEventListener("click", () => {
//       const dropdownContent = header.nextElementSibling;
//       const dropdownItems = dropdownContent.querySelectorAll('span').length;
//       const dropdownHeight = dropdownContent.querySelector('span').scrollHeight * dropdownItems + 30;

//       document.querySelectorAll(".dropdown-content").forEach((content) => {
//         if (content !== dropdownContent) {
//           content.style.height = "0px";
//           content.previousElementSibling.querySelector("svg").style.transform = "rotate(0deg)";
//         }
//       });

//       const currentHeight = parseInt(window.getComputedStyle(dropdownContent).height, 10);

//       if (currentHeight === 0) {
//         dropdownContent.style.height = `${dropdownHeight}px`;
//         header.querySelector("svg").style.transform = "rotate(180deg)";
//       } else {
//         dropdownContent.style.height = "0px";
//         header.querySelector("svg").style.transform = "rotate(0deg)";
//       }
//     });
//   });

// });

const initializeFloatingMegaMenuLegacy = () => {
  const headerFloatingMegaMenu = document.querySelector('.header-floating-mega-menu');
  if (!headerFloatingMegaMenu || headerFloatingMegaMenu.classList.contains('header-floating-mega-menu--simple')) {
    return;
  }

  if (window.Swiper && document.querySelector('.main-selectors-swiper')) {
    new Swiper('.main-selectors-swiper', {
      spaceBetween: 30,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 2,
      freeModeMomentumBounce: true,
    });
  }

  document.querySelectorAll('.dropdown-content-show-more').forEach(button => {
    button.addEventListener('click', function () {
      const dropdownContent = this.parentElement;
      const spans = dropdownContent.querySelectorAll("span");
      const dropdownItems = spans.length;
      if (dropdownItems === 0) {
        return;
      }
      const prevHeight = spans[0].scrollHeight * 3 + 51;
      const dropdownHeight = spans[0].scrollHeight * dropdownItems + 30;
      const hiddenItems = dropdownContent.querySelectorAll('.dropdown-content-hidden');

      if (this.textContent === "+Show more") {
        hiddenItems.forEach(item => {
          item.style.display = "block";
        });
        dropdownContent.style.height = `${dropdownHeight}px`;
        this.textContent = "-Show less";
      } else {
        hiddenItems.forEach(item => {
          item.style.display = "none";
          dropdownContent.style.height = `${prevHeight}px`;
        });
        this.textContent = "+Show more";
      }
    });
  });

  const dropdownHeaders = document.querySelectorAll(".link-dropdown-header");
  const dropdownItems = document.querySelectorAll('.link-dropdown-item');
  const firstDropdownHeader = document.querySelector('.link-dropdown-item .link-dropdown-header');
  if (dropdownHeaders.length === 0 || dropdownItems.length === 0) {
    return;
  }

  const closeDropdowns = () => {
    document.querySelectorAll(".dropdown-content").forEach((content) => {
      content.style.height = "0px";
      content.previousElementSibling.querySelector("svg").style.transform =
        "rotate(0deg)";
    });
  };

  const handleDropdownToggle = (header) => {
    const dropdownContent = header.nextElementSibling;
    const spans = dropdownContent.querySelectorAll("span");
    const dropdownItemsCount = spans.length;

    if (dropdownItemsCount > 0) {
      const dropdownHeight = dropdownItemsCount > 3 ? spans[0].scrollHeight * 3 + 51 : spans[0].scrollHeight * dropdownItemsCount + 30;
      closeDropdowns();
      const currentHeight = parseInt(window.getComputedStyle(dropdownContent).height, 10);

      if (currentHeight === 0) {
        dropdownContent.style.height = `${dropdownHeight}px`;
        header.querySelector("svg").style.transform = "rotate(180deg)";
        dropdownContent.parentElement.classList.add('active');
      } else {
        dropdownContent.style.height = "0px";
        header.querySelector("svg").style.transform = "rotate(0deg)";
        dropdownContent.parentElement.classList.remove('active');
      }
    } else {
      console.warn('No spans found in dropdownContent');
    }
  };

  const firstDropdownItem = dropdownItems[0];
  const firstParent = firstDropdownItem.getAttribute('data-parent');
  dropdownItems.forEach(item => {
    if (item.getAttribute('data-parent') === firstParent) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });

  const toggleHeaderMenu = document.querySelector('.toggle-header-menu');
  if (toggleHeaderMenu && firstDropdownHeader) {
    toggleHeaderMenu.addEventListener('click', function(){
      handleDropdownToggle(firstDropdownHeader);
    });
  }

  dropdownHeaders.forEach((header) => {
    header.addEventListener("click", (event) => {
      if (event.target.tagName.toLowerCase() === "a" || event.target.closest("a")) {
        return;
      }
      handleDropdownToggle(header);
    });
  });

  const mainSelectors = document.querySelector('.main-selectors');
  if (!mainSelectors) {
    return;
  }
  let currentActive = mainSelectors.querySelector('span');
  if (!currentActive) {
    return;
  }
  let previousIndexId = parseInt(currentActive.getAttribute('data-index-id'), 10);

  mainSelectors.addEventListener('click', function (event) {
    if (event.target.tagName === 'SPAN' && event.target.textContent.trim() !== 'Sale') {
      const selectedCategory = event.target.textContent.trim();
      const newIndexId = parseInt(event.target.getAttribute('data-index-id'), 10);

      if (!document.querySelector(`.link-dropdown-item[data-parent="${selectedCategory}"]`)) {
        closeDropdowns();
      }

      mainSelectors.querySelectorAll('span').forEach(span => {
        span.classList.remove('active');
      });
      dropdownItems.forEach(item => {
        item.classList.remove('active', 'active-left', 'active-right');
      });

      event.target.classList.add('active');

      dropdownItems.forEach(item => {
        if (item.getAttribute('data-parent') === selectedCategory) {
          item.style.display = 'block';
          item.classList.add('active');

          if (newIndexId > previousIndexId) {
            item.classList.add('active-right');
          } else if (newIndexId < previousIndexId) {
            item.classList.add('active-left');
          }

          handleDropdownToggle(document.querySelector(`.link-dropdown-item[data-parent="${item.getAttribute('data-parent')}"] .link-dropdown-header`));
        } else {
          item.style.display = 'none';
          item.classList.remove('active');
        }
      });

      currentActive = event.target;
      previousIndexId = newIndexId;
    }
  });
};

const initializeFloatingMegaMenuSimple = () => {
  const menu = document.querySelector('.header-floating-mega-menu--simple');
  if (!menu) {
    return;
  }

  const panels = Array.from(menu.querySelectorAll('[data-simple-panel]'));
  const rootPanel = menu.querySelector('[data-simple-panel="root"]');
  if (!rootPanel || panels.length === 0) {
    return;
  }

  const toggleButtons = menu.querySelectorAll('[data-simple-open]');
  const backButtons = menu.querySelectorAll('[data-simple-back]');

  const activatePanel = (panelId) => {
    panels.forEach(panel => {
      const isActive = panel.getAttribute('data-simple-panel') === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    toggleButtons.forEach(button => {
      const isExpanded = button.getAttribute('data-simple-open') === panelId;
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  };

  const resetPanels = () => activatePanel('root');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-simple-open');
      if (target) {
        activatePanel(target);
      }
    });
  });

  backButtons.forEach(button => {
    button.addEventListener('click', () => {
      activatePanel('root');
    });
  });

  const toggleHeaderMenu = document.querySelector('.toggle-header-menu');
  if (toggleHeaderMenu) {
    toggleHeaderMenu.addEventListener('click', () => {
      requestAnimationFrame(() => {
        if (menu.classList.contains('active')) {
          resetPanels();
        }
      });
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (!menu.classList.contains('active')) {
          resetPanels();
        }
      }
    });
  });
  observer.observe(menu, { attributes: true });

  resetPanels();
};

document.addEventListener("DOMContentLoaded", () => {
  initializeFloatingMegaMenuLegacy();
  initializeFloatingMegaMenuSimple();
});

// Tab handling functionality
const initializeTabs = () => {
  const sizeTabs = document.querySelectorAll('.product-popup-size__tab');
  const tableBodies = document.querySelectorAll('.product-popup-size__table tbody');

  const sizeElements = document.querySelectorAll(
    '.product-popup-size__tables table[data-size], ' +
    '.product-popup-size__table tbody[data-size], ' +
    '.product-popup-size__table--wrapper[data-size]'
  );
  
  const handleTabClick = (tab) => {
    const size = tab.getAttribute('data-size');
    sizeElements.forEach((el) => {
      if (el.getAttribute('data-size') === size) {

        const tag = el.tagName.toLowerCase();

        if (tag === 'table') {
          el.style.display = 'table';
        } else if (tag === 'tbody') {
          el.style.display = 'table-row-group';
        } else if (tag === 'div') {
          el.style.display = 'flex'; 
        }
      } else {
        el.style.display = 'none';
      }
    });
  };

};

// Modal button handling
const handleClick = function(event) {
  event.preventDefault();
  const modalDialog = this.closest('modal-dialog');
  if (modalDialog && !modalDialog.closest('.quick-view-popup')) {
    document.body.classList.remove('overflow-hidden');
  }
  modalDialog.removeAttribute('open');
};

const addClickListener = (button) => {
  button.removeEventListener('click', handleClick);
  button.addEventListener('click', handleClick);
};

const initializeButtons = () => {
  const buttons = document.querySelectorAll('.product-popup-modal-size__toggle');
  buttons.forEach(addClickListener);
};

// Mutation observer handling
const checkMutations = (mutations) => {
  let hasRelevantChanges = false;
  
  mutations.forEach((mutation) => {
    // Check for attribute changes
    if (mutation.type === 'attributes') {
      hasRelevantChanges = true;
      return;
    }
    
    // Check added nodes
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.matches('.product-popup-modal-size__toggle, .product-popup-size__tab') || 
          node.querySelector('.product-popup-modal-size__toggle, .product-popup-size__tab')
        ) {
          hasRelevantChanges = true;
        }
      }
    });
    
    // Check removed nodes
    mutation.removedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.matches('.product-popup-modal-size__toggle, .product-popup-size__tab') || 
          node.querySelector('.product-popup-modal-size__toggle, .product-popup-size__tab')
        ) {
          hasRelevantChanges = true;
        }
      }
    });
  });

  // Reinitialize if relevant changes were detected
  if (hasRelevantChanges) {
    initializeButtons();
    initializeTabs();
  }
};

// Create and configure the observer
const observer = new MutationObserver(checkMutations);

const startObserving = () => {
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'open']
  });
};

// Initialize everything when DOM is ready
const initialize = () => {
  initializeButtons();
  initializeTabs();
  startObserving();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize);
} else {
  initialize();
}

// Cleanup function
const cleanup = () => {
  observer.disconnect();
  const buttons = document.querySelectorAll('.product-popup-modal-size__toggle');
  buttons.forEach(button => button.removeEventListener('click', handleClick));
  
  const tabs = document.querySelectorAll('.product-popup-size__tab');
  tabs.forEach(tab => tab.removeEventListener('click', handleTabClick));
};


// const isHomePage = window.location.pathname == '/';
// const iconAccount = document.querySelector('.header__icon.header__icon--account');
// const iconCart = document.querySelector('.header__icon.header__icon--cart');
// const search = document.querySelector('.header__icon.header__icon--search');

// const observer = new MutationObserver((mutationsList) => {
//   mutationsList.forEach((mutation) => {
//     if (mutation.attributeName === 'open') {
//       if (isHomePage && window.scrollY < 10) {
//         if (search.parentElement.getAttribute('open')) {
//           console.log('if');
//           iconAccount.style.filter = 'invert(1)'
//           iconCart.style.filter = 'invert(1)';
//         } else {
//           console.log('else');
//           iconAccount.style.filter = 'invert(0)'
//           iconCart.style.filter = 'invert(0)';
//         }
//       }

//     }
//   });
// });
// observer.observe(search.parentElement, { attributes: true });



